<template>
  <div v-if="$store.getters.isLoggedIn"
       class="navbar-submenu"
  >
    <span class="navbar-button"
          @click="showSubMenu = !showSubMenu"
    >
      <i
        v-if="stompStatus === 'connected'"
        v-help.mouse="`Online`"
        class="fas fa-circle"
        style="color: GreenYellow"
      ></i>
      <i
        v-else-if="stompStatus === 'connecting'"
        v-help.mouse="`Pripojuji se k updatum serveru`"
        style="color: Gold"
        class="fas fa-sync-alt fa-spin"
      ></i>
      <i
        v-else
        v-help.mouse="`Nelze se pripojit k updatum ze serveru`"
        class="fas fa-cloud-download-alt"
        style="color: OrangeRed"
      ></i>
    </span>
  </div>
</template>

<script>
import EventBus from 'CORE/bus'

export default {
    name: 'OnlineUpdates',
    computed: {
        // connected, connecting, disconnected
        stompStatus() {
            return this.$store.getters.stompStatus
        },
    },
    async mounted() {
        EventBus.$on('STOMP_STATUS', status => {
            if (status === 'disconnected') {
                // eslint-disable-next-line no-new
                new Notification('ASD', { body: 'Updaty odpojeny!' })
            }
        })
    },
}
</script>

<style scoped lang="scss">
.navbar-submenu {
    width: 30px;
    height: 30px;
    text-align: center;
    line-height: 28px;
}
</style>
